export class RouterStates {
  static login: string = 'login';
  static selectPortal = 'select-portal';

  static external: string = ':clientName';
  static selectLanguage = 'select-language';
  static termsAndConditions: string = 'login/terms-and-conditions';

  static error = 'error';
  static errorCode = RouterStates.error + '/:code';
}
